/* ════════════════════════════════════════════════════════════
   YOURAYOU — PackSelect
   Module de sélection de pack partagé (Starter + Refill).
   Port vanilla du prototype Claude Design (App.jsx + ColorDrawer.jsx).

   Contrat DOM (rendu par pack-selector.liquid / pack-drawer.liquid) :
     #pack-sets  > .pack-set[data-set-key,data-count,data-price]
     #pack-slots (rempli par le JS)
     #pack-hint
     #pack-scrim, #pack-drawer (+ vues grille/détail)
     #shades-data (JSON), #kit-data (JSON, optionnel pour les chips Inclus)

   Usage :
     YOURAYOU.PackSelect.init({
       cta: ['#cta', '#cta-sticky'],   // boutons add-to-cart
       form: '#product-form-starter',  // form fallback
       priceEl: '#p-price',            // élément prix à synchroniser
       fallbackMax: 2                  // si aucun bloc kit_choice
     });
   Émet `pack:setchange` sur document ({detail:{key}}) à chaque changement de set.
   ════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  window.YOURAYOU = window.YOURAYOU || {};
  if (window.YOURAYOU.PackSelect) return;

  var ICONS = {
    layer:   '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4.5" width="18" height="15" rx="2"/><path d="M6.2 16V10.5a1.3 1.3 0 0 1 2.6 0V16"/><path d="M10.7 16V10.5a1.3 1.3 0 0 1 2.6 0V16"/><path d="M15.2 16V10.5a1.3 1.3 0 0 1 2.6 0V16"/></svg>',
    lamp:    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"><rect x="4" y="6" width="16" height="6.5" rx="2.2"/><line x1="10.8" y1="9.3" x2="13.2" y2="9.3"/><line x1="8" y1="12.5" x2="5.5" y2="18.5"/><line x1="16" y1="12.5" x2="18.5" y2="18.5"/></svg>',
    file:    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"><rect x="3.2" y="8.5" width="9.5" height="9.5" rx="1.2"/><line x1="3.2" y1="11" x2="12.7" y2="11"/><rect x="15.2" y="4.2" width="2.3" height="15" rx="1.15" transform="rotate(22 16.3 11.7)"/></svg>',
    prep:    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"><rect x="3.2" y="8.5" width="9.5" height="9.5" rx="1.2"/><line x1="3.2" y1="11" x2="12.7" y2="11"/><rect x="15.2" y="4.2" width="2.3" height="15" rx="1.15" transform="rotate(22 16.3 11.7)"/></svg>',
    tin:     '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"><rect x="2.5" y="6" width="19" height="12" rx="2"/><rect x="4.6" y="8" width="14.8" height="8" rx="1.2"/></svg>',
    topcoat: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"><rect x="8" y="10" width="8" height="10" rx="1.3"/><rect x="10" y="7.6" width="4" height="2.6"/><rect x="9.3" y="3" width="5.4" height="4.6" rx="1"/></svg>',
    remover: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3.6C12 3.6 17.5 10.5 17.5 14.5a5.5 5.5 0 0 1-11 0C6.5 10.5 12 3.6 12 3.6Z"/><path d="M10 15a2.4 2.4 0 0 0 1.4 2.2"/></svg>',
    buffer:  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"><polygon points="12,3 14,9 21,9 15.5,13.5 17.5,20 12,16 6.5,20 8.5,13.5 3,9 10,9"/></svg>',
    pstick:  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3 13.7 6.5 13.1 19a1.1 1.1 0 0 1-2.2 0L10.3 6.5Z"/><line x1="10.7" y1="9.5" x2="13.3" y2="9.5"/></svg>'
  };
  var IC_ZOOM = '<svg viewBox="0 0 24 24"><circle cx="11" cy="11" r="7"/><line x1="16.5" y1="16.5" x2="22" y2="22"/><line x1="11" y1="8" x2="11" y2="14"/><line x1="8" y1="11" x2="14" y2="11"/></svg>';
  var IC_VOIR = '<svg viewBox="0 0 24 24"><circle cx="11" cy="11" r="7"/><line x1="16.5" y1="16.5" x2="22" y2="22"/></svg>';

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function slotLabel(n) { return (n < 10 ? 'Teinte 0' + n : 'Teinte ' + n); }

  function init(opts) {
    opts = opts || {};
    var slotsEl = document.getElementById('pack-slots');
    var drawer = document.getElementById('pack-drawer');
    if (!slotsEl || !drawer) return; // pas sur une page pack

    /* ── i18n ── */
    var hero = document.querySelector('.ya-hero[data-i18n-add-to-cart]');
    var L = {
      addToCart: hero ? hero.getAttribute('data-i18n-add-to-cart') : 'Ajouter au panier',
      title:  drawer.getAttribute('data-i18n-title') || 'Teinte',
      voir:   drawer.getAttribute('data-i18n-voir') || 'Voir',
      add:    drawer.getAttribute('data-i18n-add') || 'Ajouter',
      inPack: drawer.getAttribute('data-i18n-in-pack') || 'Déjà dans le pack',
      empty:  drawer.getAttribute('data-i18n-empty') || 'Aucune teinte.',
      soldOut: drawer.getAttribute('data-i18n-sold-out') || 'Épuisé'
    };

    /* ── Données teintes ── */
    var shades = [];
    var shadesEl = document.getElementById('shades-data');
    if (shadesEl) {
      try { shades = JSON.parse(shadesEl.textContent) || []; }
      catch (e) { console.error('[PackSelect] shades-data invalide', e); }
    }
    var shadeByName = {};
    shades.forEach(function (s, i) { s._i = i; shadeByName[s.name] = s; });
    function gridImg(s)   { return s.swatch || s.preview || (s.images && s.images[0]) || ''; }
    function slotImg(s)   { return s.swatch || s.preview || ''; }
    function detailImg(s) { return s.preview || (s.images && s.images[0]) || s.swatch || ''; }

    /* ── Données « Inclus » (#kit-data) ── */
    var kitData = {};
    var kitEl = document.getElementById('kit-data');
    if (kitEl) { try { kitData = JSON.parse(kitEl.textContent) || {}; } catch (e) {} }

    /* ── Sets ── */
    var setEls = Array.prototype.slice.call(document.querySelectorAll('#pack-sets .pack-set'));
    var sets = setEls.map(function (el) {
      return {
        el: el,
        key: el.getAttribute('data-set-key') || '',
        name: el.getAttribute('data-set-name') || '',
        count: parseInt(el.getAttribute('data-count'), 10) || 1,
        price: el.getAttribute('data-price') || '',
        variantId: el.getAttribute('data-variant-id') || ''
      };
    });
    var maxCols = sets.length
      ? Math.max.apply(null, sets.map(function (s) { return s.count; }))
      : (parseInt(opts.fallbackMax, 10) || 3);

    var activeSet = sets[0] || null;
    var maxD = activeSet ? activeSet.count : (parseInt(opts.fallbackMax, 10) || 3);

    /* ── State ── */
    var slots = [];
    for (var i = 0; i < maxD; i++) slots.push(null);
    var picker = { open: false, slot: 0, mode: 'grid', detailIdx: 0, imgIdx: 0 };

    function filledCount() { return slots.filter(Boolean).length; }
    function activePrice() { return activeSet ? activeSet.price : ''; }
    // Synchronise l'input variant du form sur le set actif → le bon prix est facturé.
    function syncVariant() {
      if (!activeSet || !activeSet.variantId) return;
      var idInput = (opts.form && $(opts.form + ' input[name="id"]')) || document.querySelector('input[name="id"]');
      if (idInput) idInput.value = activeSet.variantId;
    }

    /* ════════ Chips « Inclus » ════════ */
    function renderChips() {
      Object.keys(kitData).forEach(function (key) {
        var box = document.querySelector('.pack-set__chips[data-incl-for="' + key + '"]');
        if (!box) return;
        var items = (kitData[key] && kitData[key].items) || [];
        box.innerHTML = items.map(function (it) {
          var icon = ICONS[it.icon] || '';
          var note = it.qty ? '<span class="pack-chip__note">' + esc(it.qty) + '</span>' : '';
          return '<span class="pack-chip">' + icon + esc(it.n) + note + '</span>';
        }).join('');
      });
    }

    /* ════════ Slots ════════ */
    function renderSlots() {
      slotsEl.style.gridTemplateColumns = 'repeat(' + maxCols + ', minmax(0, 1fr))';
      var html = '';
      for (var i = 0; i < maxD; i++) {
        var name = slots[i];
        var s = name ? shadeByName[name] : null;
        var label = slotLabel(i + 1);
        if (s) {
          var img = slotImg(s);
          html += '<div class="pack-slot is-filled" data-slot="' + i + '">'
            + '<div class="pack-slot__frame">'
            + (img ? '<img class="pack-slot__nail" src="' + esc(img) + '" alt="' + esc(name) + '" loading="lazy">'
                   : '<span class="pack-slot__nail--ph"></span>')
            + '<span class="pack-slot__zoom">' + IC_ZOOM + '</span>'
            + '<button type="button" class="pack-slot__remove" data-remove="' + i + '" aria-label="Retirer">&times;</button>'
            + '</div>'
            + '<div class="pack-slot__caption"><div class="pack-slot__num">' + esc(label) + '</div>'
            + '<div class="pack-slot__shade">' + esc(name) + '</div></div>'
            + '</div>';
        } else {
          html += '<div class="pack-slot is-empty" data-slot="' + i + '">'
            + '<div class="pack-slot__frame"><span class="pack-slot__plus">+</span></div>'
            + '<div class="pack-slot__caption"><div class="pack-slot__num">' + esc(label) + '</div></div>'
            + '</div>';
        }
      }
      slotsEl.innerHTML = html;
    }

    /* ════════ Set selection ════════ */
    function selectSet(key) {
      var next = sets.filter(function (s) { return s.key === key; })[0];
      if (!next) return;
      activeSet = next;
      syncVariant();
      maxD = next.count;
      sets.forEach(function (s) { s.el.classList.toggle('is-active', s === next); });
      // redimensionne en préservant les picks
      var resized = [];
      for (var i = 0; i < maxD; i++) resized.push(slots[i] || null);
      slots = resized;
      var priceEl = opts.priceEl ? $(opts.priceEl) : null;
      if (priceEl && next.price) priceEl.textContent = next.price;
      renderSlots();
      updateCta();
      document.dispatchEvent(new CustomEvent('pack:setchange', { detail: { key: key } }));
    }

    /* ════════ CTA ════════ */
    var ctaEls = (opts.cta || []).map(function (sel) { return $(sel); }).filter(Boolean);
    function updateCta() {
      var ready = filledCount() === maxD && maxD > 0;
      var label = ready && activePrice() ? (L.addToCart + ' — ' + activePrice()) : L.addToCart;
      ctaEls.forEach(function (btn) {
        btn.textContent = label;
        btn.disabled = !ready;
        btn.classList.toggle('is-ready', ready);
      });
    }

    /* ════════ Drawer : ouverture/fermeture ════════ */
    var scrim = document.getElementById('pack-scrim');
    var gridView = document.getElementById('pack-grid-view');
    var detailView = document.getElementById('pack-detail-view');
    var gridEl = document.getElementById('pack-grid');
    var titleEl = document.getElementById('pack-drawer-title');

    function lockBody(lock) {
      if (lock) {
        var sb = window.innerWidth - document.documentElement.clientWidth;
        document.body.style.overflow = 'hidden';
        document.body.style.paddingRight = sb + 'px';
      } else {
        document.body.style.overflow = '';
        document.body.style.paddingRight = '';
      }
    }
    function showDrawer() {
      drawer.classList.add('is-open');
      scrim.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      lockBody(true);
      picker.open = true;
    }
    function closeDrawer() {
      drawer.classList.remove('is-open');
      scrim.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      lockBody(false);
      picker.open = false;
    }
    function showGrid() {
      detailView.hidden = true;
      gridView.hidden = false;
      picker.mode = 'grid';
    }
    function showDetail() {
      gridView.hidden = true;
      detailView.hidden = false;
      picker.mode = 'detail';
    }

    function openSlot(i) {
      picker.slot = i;
      if (titleEl) titleEl.textContent = slotLabel(i + 1);
      var name = slots[i];
      if (name && shadeByName[name]) {
        renderGrid();
        openDetail(shadeByName[name]._i);
      } else {
        renderGrid();
        showGrid();
        var body = $('.pack-drawer__body', gridView);
        if (body) body.scrollTop = 0;
      }
      showDrawer();
    }

    /* ════════ Grille ════════ */
    function renderGrid() {
      if (!shades.length) { gridEl.innerHTML = '<div class="pack-drawer__empty">' + esc(L.empty) + '</div>'; return; }
      var picked = slots[picker.slot];
      gridEl.innerHTML = shades.map(function (s) {
        var img = gridImg(s);
        var unavail = s.available === false;
        return '<div class="pack-card' + (s.name === picked ? ' is-picked' : '') + (unavail ? ' is-unavailable' : '') + '" data-idx="' + s._i + '"' + (unavail ? ' aria-disabled="true"' : '') + '>'
          + '<div class="pack-card__vis">'
          + (img ? '<img src="' + esc(img) + '" alt="' + esc(s.name) + '" loading="lazy">' : '<span class="pack-card__vis-ph"></span>')
          + (unavail ? '<span class="pack-card__soldout">' + esc(L.soldOut) + '</span>' : '')
          + '</div>'
          + '<div class="pack-card__meta"><div class="pack-card__name">' + esc(s.name) + '</div>'
          + (unavail ? '' : '<span class="pack-card__voir">' + IC_VOIR + ' ' + esc(L.voir) + '</span>') + '</div>'
          + '</div>';
      }).join('');
    }

    /* ════════ Détail « Voir » ════════ */
    var dImg = document.getElementById('pack-detail-img');
    var dFam = document.getElementById('pack-detail-fam');
    var dName = document.getElementById('pack-detail-name');
    var dDesc = document.getElementById('pack-detail-desc');
    var dDots = document.getElementById('pack-detail-dots');
    var dAdd = document.getElementById('pack-detail-add');

    // Images du produit courant (fallback : image unique si pas de galerie)
    function shadeImages(s) {
      return (s && s.images && s.images.length) ? s.images : [detailImg(s)].filter(Boolean);
    }

    function renderDetail() {
      var s = shades[picker.detailIdx];
      if (!s) return;
      var imgs = shadeImages(s);
      if (picker.imgIdx >= imgs.length) picker.imgIdx = 0;
      if (dImg) { dImg.src = imgs[picker.imgIdx] || ''; dImg.alt = s.name; }
      if (dFam) dFam.textContent = s.family || '';
      if (dName) dName.textContent = s.name;
      if (dDesc) dDesc.textContent = s.desc || '';
      var inPack = slots[picker.slot] === s.name;
      var unavail = s.available === false;
      if (dAdd) {
        dAdd.classList.toggle('is-in-pack', inPack);
        dAdd.disabled = unavail;
        dAdd.innerHTML = unavail
          ? esc(L.soldOut)
          : (inPack
            ? esc(L.inPack)
            : esc(L.add) + ' — ' + esc(slotLabel(picker.slot + 1)) + '<span class="pack-detail__add-plus">+</span>');
      }
      // Flèches + dots seulement si le produit a plusieurs images
      var multi = imgs.length > 1;
      if (dPrev) dPrev.style.display = multi ? '' : 'none';
      if (dNext) dNext.style.display = multi ? '' : 'none';
      if (dDots) {
        dDots.innerHTML = multi
          ? imgs.map(function (_, i) { return '<span class="pack-detail__dot' + (i === picker.imgIdx ? ' on' : '') + '" data-dot="' + i + '"></span>'; }).join('')
          : '';
      }
    }
    function openDetail(idx) {
      picker.detailIdx = idx;
      picker.imgIdx = 0;
      showDetail();
      renderDetail();
    }
    function detailGo(dir) {
      var imgs = shadeImages(shades[picker.detailIdx]);
      if (imgs.length < 2) return;
      picker.imgIdx = (picker.imgIdx + dir + imgs.length) % imgs.length;
      renderDetail();
    }

    /* ════════ Mutations slots ════════ */
    function addShade(s) {
      if (s && s.available === false) return;
      slots[picker.slot] = s.name;
      renderSlots();
      updateCta();
      closeDrawer();
    }
    function removeShade(i) {
      slots[i] = null;
      renderSlots();
      updateCta();
    }

    /* ════════ Add to cart ════════ */
    function handleAddToCart() {
      if (filledCount() !== maxD) return;
      var variantId = document.querySelector('input[name="id"]');
      var properties = {};
      slots.forEach(function (color, i) { if (color) properties['Teinte ' + (i + 1)] = color; });
      if (activeSet && activeSet.name) properties['_set'] = activeSet.name;
      if (variantId && typeof YOURAYOUCart !== 'undefined') {
        var addThen = function () {
          return YOURAYOUCart.addToCart(parseInt(variantId.value, 10), 1, properties);
        };
        var editLine = window.__YA_EDIT_LINE;
        (editLine && typeof YOURAYOUCart.removeFromCart === 'function'
          ? YOURAYOUCart.removeFromCart(editLine).then(addThen)
          : addThen()
        ).then(function (response) {
          window.__YA_EDIT_LINE = null;
          // Erreur (rupture, réseau…) : feedback explicite, pas de tiroir vide
          if (response && response._error) {
            if (window.YOURAYOU && typeof YOURAYOU.openCartDrawer === 'function') {
              YOURAYOU.openCartDrawer();
              if (typeof YOURAYOU.showCartError === 'function') YOURAYOU.showCartError(response.description || response.message);
            }
            return;
          }
          // Ouvre le tiroir panier si dispo, sinon fallback page /cart
          if (window.YOURAYOU && typeof YOURAYOU.openCartDrawer === 'function') {
            if (typeof YOURAYOU.renderCartDrawer === 'function') YOURAYOU.renderCartDrawer(response);
            if (typeof YOURAYOUCart.updateBadge === 'function') YOURAYOUCart.updateBadge(response);
            YOURAYOU.openCartDrawer();
          } else {
            window.location.href = '/cart';
          }
        });
      } else if (variantId && opts.form) {
        var form = $(opts.form);
        if (form) {
          slots.forEach(function (color, i) {
            if (!color) return;
            var inp = document.createElement('input');
            inp.type = 'hidden';
            inp.name = 'properties[Teinte ' + (i + 1) + ']';
            inp.value = color;
            form.appendChild(inp);
          });
          form.submit();
        }
      }
    }

    /* ════════ Deep-link (?teintes= / ?teinte= + &edit=) ════════ */
    function applyDeepLink() {
      var params = new URLSearchParams(window.location.search);
      var raw = params.get('teintes') || params.get('teinte');
      if (!raw) return;
      var wanted = raw.split(',').map(function (x) {
        return decodeURIComponent(x.replace(/\+/g, ' ')).trim();
      }).filter(Boolean);
      if (!wanted.length) return;
      var resolved = [];
      wanted.forEach(function (key) {
        var s = shadeByName[key] || shades.filter(function (x) { return x.handle === key; })[0];
        if (s && resolved.indexOf(s.name) === -1) resolved.push(s.name);
      });
      if (!resolved.length) return;
      // pré-sélection one-shot du set : count === N, sinon plus petit set ≥ N, sinon plus grand
      if (sets.length) {
        var exact = sets.filter(function (s) { return s.count === resolved.length; })[0];
        var fitting = sets.filter(function (s) { return s.count >= resolved.length; })
                          .sort(function (a, b) { return a.count - b.count; })[0];
        var biggest = sets.slice().sort(function (a, b) { return b.count - a.count; })[0];
        var target = exact || fitting || biggest;
        if (target) selectSet(target.key);
      }
      for (var i = 0; i < maxD; i++) slots[i] = resolved[i] || null;
      renderSlots();
      updateCta();
      var editKey = params.get('edit');
      if (editKey) window.__YA_EDIT_LINE = editKey;
    }

    /* ════════ Listeners ════════ */
    // sets
    sets.forEach(function (s) {
      s.el.addEventListener('click', function () { selectSet(s.key); });
    });
    // slots (délégation : ouverture + retrait)
    slotsEl.addEventListener('click', function (e) {
      var rm = e.target.closest('[data-remove]');
      if (rm) { e.stopPropagation(); removeShade(parseInt(rm.getAttribute('data-remove'), 10)); return; }
      var slot = e.target.closest('[data-slot]');
      if (!slot) return;
      openSlot(parseInt(slot.getAttribute('data-slot'), 10));
    });
    // grille (carte → détail)
    gridEl.addEventListener('click', function (e) {
      var card = e.target.closest('.pack-card');
      if (!card || card.classList.contains('is-unavailable')) return;
      openDetail(parseInt(card.getAttribute('data-idx'), 10));
    });
    // détail
    var dPrev = document.getElementById('pack-detail-prev');
    var dNext = document.getElementById('pack-detail-next');
    var dBack = document.getElementById('pack-detail-back');
    if (dPrev) dPrev.addEventListener('click', function () { detailGo(-1); });
    if (dNext) dNext.addEventListener('click', function () { detailGo(1); });
    if (dBack) dBack.addEventListener('click', function () { renderGrid(); showGrid(); });
    if (dDots) dDots.addEventListener('click', function (e) {
      var dot = e.target.closest('[data-dot]');
      if (dot) { picker.imgIdx = parseInt(dot.getAttribute('data-dot'), 10); renderDetail(); }
    });
    if (dAdd) dAdd.addEventListener('click', function () {
      var s = shades[picker.detailIdx];
      if (!s) return;
      if (slots[picker.slot] === s.name) closeDrawer();
      else addShade(s);
    });
    // close
    ['pack-grid-close', 'pack-detail-close'].forEach(function (id) {
      var b = document.getElementById(id);
      if (b) b.addEventListener('click', closeDrawer);
    });
    scrim.addEventListener('click', closeDrawer);
    // clavier
    window.addEventListener('keydown', function (e) {
      if (!picker.open) return;
      if (e.key === 'Escape') { picker.mode === 'detail' ? (renderGrid(), showGrid()) : closeDrawer(); }
      else if (picker.mode === 'detail') {
        if (e.key === 'ArrowRight') detailGo(1);
        if (e.key === 'ArrowLeft') detailGo(-1);
      }
    });
    // CTA
    ctaEls.forEach(function (btn) { btn.addEventListener('click', handleAddToCart); });

    /* ════════ Boot ════════ */
    // échappe les containing-blocks (overflow/transform) : drawer + scrim en enfant de body
    document.body.appendChild(scrim);
    document.body.appendChild(drawer);

    renderChips();
    renderSlots();
    syncVariant();
    // prix initial = prix du set actif (cohérent avec le prototype)
    var priceEl0 = opts.priceEl ? $(opts.priceEl) : null;
    if (priceEl0 && activeSet && activeSet.price) priceEl0.textContent = activeSet.price;
    updateCta();
    applyDeepLink();

    // Sync différé (inc-grid de la section) : after-tick pour que les listeners
    // `pack:setchange` de la section soient attachés, y compris après deep-link.
    setTimeout(function () {
      if (activeSet) document.dispatchEvent(new CustomEvent('pack:setchange', { detail: { key: activeSet.key } }));
    }, 0);
  }

  /* ── Auto-init : lit la config sur [data-pack-root] (pas de dépendance d'ordre de script) ── */
  function autoInit() {
    var root = document.querySelector('[data-pack-root]');
    if (!root) return;
    init({
      cta: (root.getAttribute('data-cta') || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean),
      form: root.getAttribute('data-form') || null,
      priceEl: root.getAttribute('data-price-el') || null,
      fallbackMax: parseInt(root.getAttribute('data-fallback-max'), 10) || null
    });
  }

  window.YOURAYOU.PackSelect = { init: init };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', autoInit);
  else autoInit();
})();
